export default {
  'pages.accounting.salaryManagement.settlement.proration': '工作日精算',
  'pages.accounting.salaryManagement.settlement.prorationHelp':
    '僅基本給按{days}/{total}個工作日精算：{amount}。公司保險負擔維持正常月額。',
  'pages.accounting.salaryManagement.settlement.compensation': '額外補償',
  'pages.accounting.salaryManagement.settlement.compensationHelp':
    '正常成本之外，本月一次計入補償{amount}。不會產生其他月份薪資或實際付款紀錄。',
  'pages.accounting.salaryManagement.settlement.monthlyBase': '原月額基本給：{amount}',
  'pages.accounting.salaryManagement.settlement.reviewHelp':
    '入離職日期與已確認的個別精算條件不同，請核對薪資和成本。',
  'pages.interviewList.modal.createTitle': '面試資訊新增',
  'pages.interviewList.modal.editTitle': '面試資訊編輯',
  'pages.interviewList.field.applicationDate': '應募日期',
  'pages.interviewList.field.candidateName': '候選者姓名',
  'pages.interviewList.field.appliedPosition': '應募職種',
  'pages.interviewList.field.sourceChannel': '應募渠道',
  'pages.interviewList.field.visaType': '在留資格',
  'pages.interviewList.field.interviewDate': '面試日期',
  'pages.interviewList.field.interviewForm': '面試形式',
  'pages.interviewList.field.totalScore': '總分',
  'pages.interviewList.field.interviewResult': '面試結果',
  'pages.interviewList.field.interviewRemarks': '面試備註',
  'pages.interviewList.option.pass': '合格',
  'pages.interviewList.option.fail': '不合格',
  'pages.interviewList.option.pending': '保留',
  'pages.interviewList.action.save': '儲存',
  'pages.interviewList.action.cancel': '取消',
  'pages.interviewList.validation.candidateName': '請輸入候選者姓名。',
  'pages.interviewList.simple.basic': '基本資訊',
  'pages.interviewList.simple.gender': '性別',
  'pages.interviewList.simple.birthday': '出生日期',
  'pages.interviewList.simple.age': '{age}歲',
  'pages.interviewList.simple.country': '國籍',
  'pages.interviewList.simple.region': '省份／地區',
  'pages.interviewList.simple.visa': '在留資訊',
  'pages.interviewList.simple.visaExpiry': '在留有效期',
  'pages.interviewList.simple.remainingDays': '剩餘 {days} 天',
  'pages.interviewList.simple.screening': '履歷篩選',
  'pages.interviewList.simple.screeningResult': '篩選結果',
  'pages.interviewList.simple.screeningRemarks': '篩選備註',
  'pages.interviewList.simple.first': '一次面試',
  'pages.interviewList.simple.interviewer': '面試擔當',
  'pages.interviewList.simple.interviewStatus': '實施狀態',
  'pages.interviewList.simple.skill': '經驗技能',
  'pages.interviewList.simple.communication': '溝通能力',
  'pages.interviewList.simple.thinking': '主動性／思考力',
  'pages.interviewList.simple.personality': '人物適性',
  'pages.interviewList.simple.motivation': '志望動機',
  'pages.interviewList.simple.japanese': '日語能力',
  'pages.interviewList.simple.scoreGuide': '評分標準',
  'pages.interviewList.simple.evaluation': '面試評價',
  'pages.interviewList.simple.rollback': '退回履歷篩選（清除一面資訊）',
  'pages.interviewList.simple.training': '研修',
  'pages.interviewList.simple.trainingHint':
    '人事只登記開始日期。研修期間、測試及評價由開發部管理。',
  'pages.interviewList.simple.trainingStart': '研修開始日期',
  'pages.interviewList.simple.developmentManaged': '開發部已接手，請在進度日曆中修改開始日期。',
  'pages.interviewList.simple.followup': '開發部後續跟進（唯讀）',
  'pages.interviewList.simple.trainingEnd': '研修結束日期',
  'pages.interviewList.simple.trainingStatus': '研修狀態',
  'pages.interviewList.simple.testDate': '測試日期',
  'pages.interviewList.simple.testResult': '測試結果',
  'pages.interviewList.simple.trainingRemarks': '研修備註',
  'pages.interviewList.simple.accountStatus': '帳號狀態',
  'pages.interviewList.simple.active': '使用中',
  'pages.interviewList.simple.inactive': '停用',
  'pages.interviewList.simple.accountNotCreated': '未生成',
  'pages.interviewList.simple.pendingTrainings': '人事登記・待安排研修',
  'pages.interviewList.simple.arrangeTraining': '安排',
  'pages.interviewList.simple.waitingAccount': '等待人事生成帳號',
  'pages.interviewList.simple.completePeriod': '請正確填寫開始和結束日期。',
  'pages.interviewList.simple.status.not_started': '未實施',
  'pages.interviewList.simple.status.completed': '已實施',
  'pages.interviewList.simple.status.declined': '辭退',
  'pages.interviewList.simple.status.absent': '無故缺席',
  'pages.dashboard.trainee': '就業導向',
  'pages.employeeList.contractType.trainee': '就業導向',
  'pages.accounting.salaryManagement.contractType.trainee': '就業導向',
  'pages.development.frontendStage': '階段1：前端學習',
  'pages.development.backendStage': '階段2：後端學習',
  'pages.development.backendProgressStage': '階段2：後端學習（SQL・Java）',
  'pages.development.displayName': '顯示名稱',
  'pages.development.sourceName': '原始名稱（影片與資料關聯用）',
  'pages.development.stageFilter': '學習階段',
  'pages.development.topicFilter': '學習主題',
  'pages.accountManagement.delete.departureRequired':
    '契約員工、正式員工停用前，請先在員工資訊中填寫離職日期。',
  'pages.accountManagement.restore': '恢復',
  'pages.accountManagement.restore.confirmTitle': '確定恢復帳號嗎？',
  'pages.accountManagement.restore.confirmDescription':
    '將恢復「{accountName}」的登入，保留的角色權限和關聯資訊將重新生效，不修改離職資訊。歷史已刪除的角色需另外重新設定。',
  'pages.accountManagement.restore.done':
    '帳號已恢復，保留的角色權限和關聯資訊已重新生效。歷史已刪除的角色需重新設定。',
  'pages.accountManagement.restore.failed': '帳號恢復失敗。',
  'pages.accounting.salaryManagement.historicalMonth': '歷史月份僅供查看。',
  'pages.accounting.salaryManagement.contractType.management': '正式員工・管理',
  'pages.accounting.salaryManagement.cost.fixedHelp':
    '案件收入為0，經營管理用總成本固定為10萬日圓。實際薪資和保險明細不變。',
  'pages.accounting.dashboard.fixedCost.note':
    '一般員工案件收入為0時，每月經營成本按10萬日圓計算；管理人員及已確認的社內員工除外。個別精算和補償單獨顯示，總成本可能與薪資及保險明細合計不同。',
  'pages.accounting.dashboard.warning.payrollDetail':
    '薪資或保險明細存在待確認資料；適用固定成本的人員仍可計算利潤。',
  'pages.layouts.userLayout.title': '我們不只是寫程式，我們在除錯未來',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼(admin/ant.design)',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.accountName.placeholder': '用戶名:',
  'pages.login.accountName.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼:',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',

  // 帳號管理畫面
  'pages.accountManagement.accountId': '帳號ID',
  'pages.accountManagement.email': '電子郵件',
  'pages.accountManagement.emailIsVerified': '電子郵件驗證狀態',
  'pages.accountManagement.phoneNumber': '手機號碼',
  'pages.accountManagement.phoneNumberInvalid': '無效的手機號碼。請使用半形數字與連字號（-）輸入。',
  'pages.accountManagement.phoneIsVerified': '手機驗證狀態',
  'pages.accountManagement.operation': '操作',
  'pages.accountManagement.update': '更新',
  'pages.accountManagement.update.process': '帳號更新中...',
  'pages.accountManagement.update.done': '帳號已更新。',
  'pages.accountManagement.accountName': '帳號名稱',
  'pages.accountManagement.account.required': '帳號名稱為必填項！',
  'pages.accountManagement.account.accountNameLength': '請輸入6～18個字元',
  'pages.accountManagement.account.accountNameInvalid':
    '帳號名稱需以英文字母開頭，僅可使用半形英數字元',
  'pages.accountManagement.passwordReset': '重設密碼',
  'pages.accountManagement.passwordReset.process': '密碼重設中...',
  'pages.accountManagement.passwordReset.done': '密碼已重設。',
  'pages.accountManagement.password.required': '密碼為必填項！',
  'pages.accountManagement.password.passwordLength': '請輸入6～18個字元',
  'pages.accountManagement.password.passwordInvalid': '密碼僅可使用半形英數字元',
  'pages.accountManagement.delete': '刪除',
  'pages.accountManagement.delete.process': '帳號刪除中...',
  'pages.accountManagement.delete.done': '帳號已刪除。',
  'pages.accountManagement.serachList': '搜尋結果',
  'pages.accountManagement.create': '新增帳號',
  'pages.accountManagement.create.process': '帳號建立中...',
  'pages.accountManagement.create.done': '帳號已建立。',
  'pages.accountManagement.selected': '已選帳號',
  'pages.accountManagement.selectedDelete': '刪除已選帳號',
  'pages.accountManagement.roleSet': '角色編輯',
  'pages.accountManagement.roleSet.view': '角色載入中...',

  // 角色管理畫面
  'pages.roleManagement.selectedDelete': '角色名稱',
  'pages.roleManagement.roleDescription': '角色說明',
  'pages.roleManagement.operation': '操作',
  'pages.roleManagement.roleList': '角色清單',
  'pages.roleManagement.createRole': '新增角色',
  'pages.roleManagement.updateRole': '更新角色',
  'pages.roleManagement.ruleNameIsRequired': '角色名稱為必填項',

  // 畫面權限管理
  'pages.pageAuthManagement.pageId': '畫面ID',
  'pages.pageAuthManagement.pageName': '畫面名稱',
  'pages.pageAuthManagement.description': '畫面說明',
  'pages.pageAuthManagement.operation': '操作',
  'pages.pageAuthManagement.auth': '編輯權限',
  'pages.pageAuthManagement.update': '套用設定',
  'pages.pageAuthManagement.serachList': '搜尋結果',
  'pages.pageAuthManagement.update.process': '畫面權限更新中...',
  'pages.pageAuthManagement.update.done': '畫面權限已更新。',
  'pages.learnTest.retryRequiredMessage':
    '正確率未達到60%，需要重新學習。完整觀看影片後，可以再次參加測試。',
  'pages.development.learnManagement.player.testAfterLearning': '學習後測試',
  'pages.development.learnManagement.player.testLockedTooltip': '完整學習影片後即可參加測試。',
  'pages.fixedAssets.group.sameName': '同名資產',
  'pages.fixedAssets.group.assetCount': '{count}件',
  'pages.fixedAssets.group.mixed': '多個',
  'pages.fixedAssets.group.expandForDetail': '展開確認',
  'pages.fixedAssets.group.expandForAction': '展開後操作',
  'pages.fixedAssets.group.countSummary': '{groups}組 / {assets}件',

  // 首頁・等級積分
  'pages.home.common.none': '-',
  'pages.home.common.pointSuffix': '積分',
  'pages.home.common.minutesSuffix': '分',
  'pages.home.notice.title': '社內公告・通知',
  'pages.home.notice.noUnread': '無未讀',
  'pages.home.notice.unreadCount': '未讀 {count} 件',
  'pages.home.notice.unread': '未讀',
  'pages.home.notice.important': '重要',
  'pages.home.notice.viewAll': '前往一覽',
  'pages.home.notice.noPublished': '暫無公開中的通知',
  'pages.home.notice.unreadModalTitle': '未讀公告',
  'pages.home.notice.noUnreadNotice': '暫無未讀公告',
  'pages.home.notice.publishDate': '發布日期: {date}',
  'pages.home.growth.level': '等級 {level}',
  'pages.home.growth.experience': '經驗值 {current}/{next}',
  'pages.home.growth.points': '積分',
  'pages.home.growth.todayUsage': '今日使用',
  'pages.home.growth.usagePoints': '使用積分',
  'pages.home.growth.gamePoints': '遊戲積分',
  'pages.home.growth.exchangeHint': '透過使用時間和遊戲挑戰累積積分，可兌換稱號和勳章。',
  'pages.home.reward.type.title': '稱號',
  'pages.home.reward.type.badge': '勳章',
  'pages.home.reward.type.icon': '圖示',
  'pages.home.reward.type.frame': '邊框',
  'pages.home.reward.type.reward': '獎勵',
  'pages.home.reward.descriptionLabel': '說明:',
  'pages.home.reward.noEquippedBadgeDescription': '暫無已裝備勳章說明。',
  'pages.home.reward.titleNotSet': '未設定稱號',
  'pages.home.reward.badgeNotSet': '未設定勳章',
  'pages.home.reward.exchangeSuccess': '獎勵兌換成功。',
  'pages.home.reward.exchangeFailed': '獎勵兌換失敗。',
  'pages.home.reward.equipSuccess': '獎勵裝備成功。',
  'pages.home.reward.equipFailed': '獎勵裝備失敗。',
  'pages.home.reward.exchangeButton': '積分兌換',
  'pages.home.reward.exchangeDrawerTitle': '積分兌換',
  'pages.home.reward.currentPoints': '目前積分',
  'pages.home.reward.empty': '暫無可兌換獎勵',
  'pages.home.reward.equipped': '裝備中',
  'pages.home.reward.equip': '裝備',
  'pages.home.reward.exchange': '兌換',
  'pages.home.game.selectionTitle': '遊戲選擇',
  'pages.home.game.modalFallbackTitle': '遊戲',
  'pages.home.game.raiden.title': '雷電遊戲',
  'pages.home.game.raiden.description': '用短時間切換專注力的射擊小遊戲。',
  'pages.home.game.frogWords.title': '青蛙過河・單字遊戲',
  'pages.home.game.frogWords.description': '輸入日中 IT 詞彙，讓青蛙一步步過河。',
  'pages.home.game.scoreGained': '{game} 分數已提交，獲得 {points} 積分。',
  'pages.home.game.scoreRecorded': '{game} 分數已記錄，今日沒有追加積分。',
  'pages.home.game.scoreSubmitFailed': '{game} 分數提交失敗。',
  'pages.home.game.leaderboardButton': '排行榜',
  'pages.home.game.leaderboardTitle': '{game} 排行榜',
  'pages.home.game.leaderboardFallbackTitle': '排行榜',
  'pages.home.game.leaderboardScore': '累計積分: {points} / 最高分: {bestScore}',
  'pages.home.game.leaderboardNoRank': '榜上無名，需要努力。',
  'pages.home.game.leaderboardMyRank': '目前第 {rank} 名。累計積分: {points}',
  'pages.home.game.leaderboardEmpty': '暫無排行榜資料。',
  'pages.home.game.leaderboardLoadFailed': '排行榜取得失敗。',
  'pages.home.reward.gitApostle.name': 'Git 使徒',
  'pages.home.reward.gitApostle.description': '適合熟悉 Git 運用的人使用的稱號。',
  'pages.home.reward.testPaladin.name': '測試聖騎士',
  'pages.home.reward.testPaladin.description': '守護測試品質的人專屬勳章。',
  'pages.home.reward.raidenPilot.name': '雷電飛行員',
  'pages.home.reward.raidenPilot.description': '適合挑戰雷電遊戲的人使用的圖示。',
  'pages.home.reward.blueFrame.name': '藍色邊框',
  'pages.home.reward.blueFrame.description': '用於稍微裝飾首頁的個人邊框。',
  'pages.home.reward.bugHunter.name': 'Bug 獵人',
  'pages.home.reward.bugHunter.description': '適合不放過小缺陷的人使用的稱號。',
  'pages.home.reward.sqlSamurai.name': 'SQL 武士',
  'pages.home.reward.sqlSamurai.description': '適合靜靜斬斷條件與連接的人使用的稱號。',
  'pages.home.reward.diffWizard.name': '差分魔術師',
  'pages.home.reward.diffWizard.description': '適合在 Review 中讀懂差分意圖的人使用的稱號。',
  'pages.home.reward.morningSprinter.name': '晨間衝刺者',
  'pages.home.reward.morningSprinter.description': '適合從清晨開始輕快推進任務的人使用的稱號。',
  'pages.home.reward.midnightDeployGuardian.name': '深夜發布守護者',
  'pages.home.reward.midnightDeployGuardian.description': '在夜晚的安靜中守護上線的人專屬稱號。',
  'pages.home.reward.specTraveler.name': '規格書旅人',
  'pages.home.reward.specTraveler.description': '適合能在規格森林中不迷路前進的人使用的稱號。',
  'pages.home.reward.commitCraftsman.name': '提交工匠',
  'pages.home.reward.commitCraftsman.description': '適合認真堆疊每一次變更的人使用的稱號。',
  'pages.home.reward.bugDetective.name': '缺陷偵探',
  'pages.home.reward.bugDetective.description': '適合從現象一路追到原因的人使用的稱號。',
  'pages.home.reward.raidenAce.name': '雷電王牌',
  'pages.home.reward.raidenAce.description': '適合在雷電遊戲中馳騁天空的人使用的稱號。',
  'pages.home.reward.raidenBulletApprentice.name': '彈幕見習生',
  'pages.home.reward.raidenBulletApprentice.description':
    '適合剛剛開始接受彈幕洗禮的人使用的稱號。',
  'pages.home.reward.raidenRookie.name': '雷電新人',
  'pages.home.reward.raidenRookie.description': '適合有勇氣按下出擊按鈕的人使用的稱號。',
  'pages.home.reward.skyDogfighter.name': '青空纏鬥者',
  'pages.home.reward.skyDogfighter.description': '適合在藍天中靈活周旋的人使用的稱號。',
  'pages.home.reward.lowAltitudeDodger.name': '低空迴避名人',
  'pages.home.reward.lowAltitudeDodger.description': '適合總能在低空閃避彈幕的人使用的稱號。',
  'pages.home.reward.laserStraightShot.name': '雷射直線派',
  'pages.home.reward.laserStraightShot.description': '適合不迷路、一路打穿的人使用的稱號。',
  'pages.home.reward.cloudSniper.name': '雲間狙擊手',
  'pages.home.reward.cloudSniper.description': '適合能從雲縫中精準命中的人使用的稱號。',
  'pages.home.reward.bossBreath.name': 'Boss前深呼吸',
  'pages.home.reward.bossBreath.description': '適合 Boss 戰前會先冷靜一下的人使用的稱號。',
  'pages.home.reward.noDamagePrayer.name': '無傷祈願兵',
  'pages.home.reward.noDamagePrayer.description': '適合一邊祈禱無傷一邊衝進去的人使用的稱號。',
  'pages.home.reward.thunderAce.name': '雷鳴王牌',
  'pages.home.reward.thunderAce.description': '適合伴隨雷鳴不斷刷新分數的人使用的稱號。',
  'pages.home.reward.airspaceCommander.name': '空域壓制隊長',
  'pages.home.reward.airspaceCommander.description': '適合面對滿屏敵人也不慌的隊長使用的稱號。',
  'pages.home.reward.lilyPadJumper.name': '荷葉跳躍者',
  'pages.home.reward.lilyPadJumper.description': '適合和青蛙一起踩著荷葉前進的人使用的稱號。',
  'pages.home.reward.wordHopper.name': '單字蹦蹦太',
  'pages.home.reward.wordHopper.description': '適合看到單字就能反射性作答的人使用的稱號。',
  'pages.home.reward.jpCnWordFerryman.name': '日中詞語擺渡人',
  'pages.home.reward.jpCnWordFerryman.description': '適合在日語和中文之間架橋的人使用的稱號。',
  'pages.home.reward.translationRiverGuide.name': '翻譯河流嚮導',
  'pages.home.reward.translationRiverGuide.description': '適合在術語之河裡帶路的人使用的稱號。',
  'pages.home.reward.lostParticleRescue.name': '迷路助詞救援隊',
  'pages.home.reward.lostParticleRescue.description': '適合溫柔拯救助詞和詞尾的人使用的稱號。',
  'pages.home.reward.termFishingMaster.name': '術語釣魚名人',
  'pages.home.reward.termFishingMaster.description': '適合能從記憶池裡釣出正確答案的人使用的稱號。',
  'pages.home.reward.frogMemoryMaster.name': '青蛙記憶大師',
  'pages.home.reward.frogMemoryMaster.description': '適合比青蛙更快記住單字的人使用的稱號。',
  'pages.home.reward.bilingualSkipKing.name': '雙語跳躍王',
  'pages.home.reward.bilingualSkipKing.description': '適合輕快跨越兩種語言的人使用的稱號。',
  'pages.home.reward.wrongAnswerRecovery.name': '錯題恢復班',
  'pages.home.reward.wrongAnswerRecovery.description':
    '適合答錯後也能立刻邁出下一步的人使用的稱號。',
  'pages.home.reward.oppositeBankSage.name': '到達對岸的賢者',
  'pages.home.reward.oppositeBankSage.description':
    '適合把詞語一路連到最後一片荷葉的人使用的稱號。',
  'pages.home.reward.quietImprover.name': '安靜的改善者',
  'pages.home.reward.quietImprover.description': '適合持續累積不起眼改善的人使用的稱號。',
  'pages.home.reward.qualityGuardianBadge.name': '品質守護徽章',
  'pages.home.reward.qualityGuardianBadge.description': '表現重視品質姿態的勳章。',
  'pages.home.reward.learningFinisherMedal.name': '學習完走獎章',
  'pages.home.reward.learningFinisherMedal.description': '表彰堅持學完能力的勳章。',
  'pages.home.reward.monthEndAttendanceMaster.name': '月末考勤大師',
  'pages.home.reward.monthEndAttendanceMaster.description': '適合不會忘記月末處理的人使用的勳章。',
  'pages.home.reward.blueLightning.name': '藍色閃電',
  'pages.home.reward.blueLightning.description': '讓首頁稍微更俐落的圖示。',
  'pages.home.reward.coffeeRefueler.name': '咖啡補給機',
  'pages.home.reward.coffeeRefueler.description': '想在專注時間放在身邊的圖示。',
  'pages.home.reward.keyboardNinja.name': '鍵盤忍者',
  'pages.home.reward.keyboardNinja.description': '適合享受高速輸入的人使用的圖示。',
  'pages.home.reward.sakuraFrame.name': '櫻花邊框',
  'pages.home.reward.sakuraFrame.description': '柔和印象的個人邊框。',
  'pages.home.reward.nightShiftFrame.name': '夜勤邊框',
  'pages.home.reward.nightShiftFrame.description': '以夜間專注作業為靈感的邊框。',
  'pages.home.reward.goldLine.name': '金色線條',
  'pages.home.reward.goldLine.description': '稍微帶來特別感的金色系邊框。',
  'pages.hrDocument.title': '文件申請',
  'pages.hrDocument.management.title': '文件申請管理',
  'pages.hrDocument.management.listTitle': '申請管理一覽',
  'pages.hrDocument.list.title': '申請一覽',
  'pages.hrDocument.detail.title': '文件申請詳情',
  'pages.hrDocument.status.0': '草稿',
  'pages.hrDocument.status.1': '待審批',
  'pages.hrDocument.status.2': '退回',
  'pages.hrDocument.status.3': '製作中',
  'pages.hrDocument.status.4': '待領取',
  'pages.hrDocument.status.5': '已完成',
  'pages.hrDocument.status.6': '已取消',
  'pages.hrDocument.delivery.download': '系統下載',
  'pages.hrDocument.delivery.pickup': '線下領取',
  'pages.hrDocument.field.requestNo': '申請編號',
  'pages.hrDocument.field.status': '狀態',
  'pages.hrDocument.field.applicant': '申請人',
  'pages.hrDocument.field.department': '所屬部門',
  'pages.hrDocument.field.documentType': '文件類型',
  'pages.hrDocument.field.quantity': '份數',
  'pages.hrDocument.field.reason': '用途・申請理由',
  'pages.hrDocument.field.destination': '提交對象',
  'pages.hrDocument.field.desiredDate': '希望交付日',
  'pages.hrDocument.field.deliveryMethod': '交付方式',
  'pages.hrDocument.field.notes': '補充說明',
  'pages.hrDocument.field.returnReason': '退回理由',
  'pages.hrDocument.field.cancelReason': '取消理由',
  'pages.hrDocument.field.actions': '操作',
  'pages.hrDocument.action.create': '新增申請',
  'pages.hrDocument.action.edit': '編輯',
  'pages.hrDocument.action.detail': '詳情',
  'pages.hrDocument.action.submit': '提交',
  'pages.hrDocument.action.cancel': '取消',
  'pages.hrDocument.action.delete': '刪除',
  'pages.hrDocument.action.download': '下載',
  'pages.hrDocument.action.approve': '同意',
  'pages.hrDocument.action.return': '退回',
  'pages.hrDocument.action.ready': '製作完成',
  'pages.hrDocument.action.complete': '交付完成',
  'pages.hrDocument.action.upload': '上傳PDF',
  'pages.hrDocument.action.confirm': '確認',
  'pages.hrDocument.action.back': '返回',
  'pages.hrDocument.confirm.submit': '確定提交該申請嗎？',
  'pages.hrDocument.confirm.cancel': '確定取消該申請嗎？',
  'pages.hrDocument.confirm.delete': '確定物理刪除該申請嗎？',
  'pages.hrDocument.confirm.approve': '確定同意該申請嗎？',
  'pages.hrDocument.confirm.ready': '確定已完成交付準備嗎？',
  'pages.hrDocument.confirm.complete': '確定文件已交付嗎？',
  'pages.hrDocument.confirm.deleteFile': '確定刪除該PDF嗎？',
  'pages.hrDocument.confirm.deleteType': '確定刪除該文件類型嗎？',
  'pages.hrDocument.filter.status': '狀態',
  'pages.hrDocument.filter.all': '全部',
  'pages.hrDocument.filter.keyword': '按申請編號、文件類型、理由搜尋',
  'pages.hrDocument.filter.managementKeyword': '按申請編號、員工姓名、理由搜尋',
  'pages.hrDocument.form.createTitle': '新增文件申請',
  'pages.hrDocument.form.editTitle': '編輯文件申請',
  'pages.hrDocument.files.title': '交付文件',
  'pages.hrDocument.files.empty': '暫無交付文件',
  'pages.hrDocument.history.title': '處理履歷',
  'pages.hrDocument.return.title': '退回文件申請',
  'pages.hrDocument.cancel.title': '取消文件申請',
  'pages.hrDocument.type.manage': '文件類型管理',
  'pages.hrDocument.type.create': '新增文件類型',
  'pages.hrDocument.type.edit': '編輯文件類型',
  'pages.hrDocument.type.code': '類型編碼',
  'pages.hrDocument.type.name': '類型名稱',
  'pages.hrDocument.type.description': '說明',
  'pages.hrDocument.type.order': '顯示順序',
  'pages.hrDocument.type.active': '有效狀態',
  'pages.hrDocument.type.enabled': '有效',
  'pages.hrDocument.type.disabled': '停用',
  'pages.hrDocument.msg.loadFailed': '文件申請載入失敗。',
  'pages.hrDocument.msg.detailFailed': '申請詳情載入失敗。',
  'pages.hrDocument.msg.actionFailed': '處理失敗。',
  'pages.hrDocument.msg.downloadFailed': '文件下載失敗。',
  'pages.hrDocument.msg.saveSuccess': '文件申請已儲存。',
  'pages.hrDocument.msg.saveFailed': '儲存失敗。',
  'pages.hrDocument.msg.submitSuccess': '文件申請已提交。',
  'pages.hrDocument.msg.cancelSuccess': '文件申請已取消。',
  'pages.hrDocument.msg.deleteSuccess': '文件申請已刪除。',
  'pages.hrDocument.msg.approveSuccess': '文件申請已同意。',
  'pages.hrDocument.msg.returnSuccess': '文件申請已退回。',
  'pages.hrDocument.msg.readySuccess': '交付準備已完成。',
  'pages.hrDocument.msg.completeSuccess': '文件交付已完成。',
  'pages.hrDocument.msg.uploadSuccess': 'PDF已上傳。',
  'pages.hrDocument.msg.uploadFailed': 'PDF上傳失敗。',
  'pages.hrDocument.msg.fileDeleteSuccess': 'PDF已刪除。',
  'pages.hrDocument.msg.typeSaveSuccess': '文件類型已儲存。',
  'pages.hrDocument.msg.typeDeleteSuccess': '文件類型已刪除。',
  'pages.hrDocument.action.save': '儲存',
  'pages.hrDocument.action.register': '登記',
  'pages.hrDocument.action.preview': 'PDF預覽',
  'pages.hrDocument.action.generate': '產生PDF',
  'pages.hrDocument.action.generateDeliver': '產生PDF並交付',
  'pages.hrDocument.action.redeliver': '重新交付',
  'pages.hrDocument.confirm.redeliver': '確定重新交付並將下載期限延長7天嗎？',
  'pages.hrDocument.confirm.deleteStamp': '確定物理刪除此電子章嗎？',
  'pages.hrDocument.type.deliveryMethods': '可用交付方式',
  'pages.hrDocument.type.allowDownload': '線上下載',
  'pages.hrDocument.type.allowPickup': '窗口領取',
  'pages.hrDocument.template.edit': '範本',
  'pages.hrDocument.template.title': '{type} 範本',
  'pages.hrDocument.template.name': '範本名稱',
  'pages.hrDocument.template.variables': '自動填入變數（點擊插入）',
  'pages.hrDocument.template.body': '範本正文',
  'pages.hrDocument.template.customFields': '產生時補充輸入項',
  'pages.hrDocument.template.fieldLabel': '項目名稱',
  'pages.hrDocument.template.required': '必填',
  'pages.hrDocument.template.addField': '新增輸入項',
  'pages.hrDocument.stamp.manage': '電子章管理',
  'pages.hrDocument.stamp.name': '電子章名稱',
  'pages.hrDocument.stamp.fileName': '登記檔案',
  'pages.hrDocument.stamp.selectPng': '選擇PNG',
  'pages.hrDocument.generate.title': '產生文件PDF',
  'pages.hrDocument.generate.stamp': '電子章',
  'pages.hrDocument.generate.noStamp': '不使用電子章',
  'pages.hrDocument.download.notice': '交付後7天內可重複下載。逾期後請聯絡HR重新交付。',
  'pages.hrDocument.download.expired': '下載期限已過，請聯絡HR重新交付。',
  'pages.hrDocument.download.expiresAt': '下載期限',
  'pages.hrDocument.download.expiredShort': '已逾期',
  'pages.hrDocument.download.countdown': '剩餘 {days}天 {hours}小時',
  'pages.hrDocument.msg.templateLoadFailed': '範本讀取失敗。',
  'pages.hrDocument.msg.templateSaveSuccess': '範本已儲存。',
  'pages.hrDocument.msg.templateSaveFailed': '範本儲存失敗。',
  'pages.hrDocument.msg.stampLoadFailed': '電子章讀取失敗。',
  'pages.hrDocument.msg.stampSaveFailed': '電子章登記失敗。',
  'pages.hrDocument.msg.generateLoadFailed': 'PDF產生資訊讀取失敗。',
  'pages.hrDocument.msg.previewFailed': 'PDF預覽產生失敗。',
  'pages.hrDocument.msg.generateSuccess': 'PDF已產生並交付。',
  'pages.hrDocument.msg.generateFailed': 'PDF產生或交付失敗。',
  'pages.hrDocument.msg.redeliverSuccess': '文件已重新交付。',
  'pages.employeeList.field.healthInsurerNo': '保險者號碼',
  'pages.employeeList.field.healthInsuranceSymbol': '被保險者證記號',
  'pages.employeeList.field.healthInsuranceNo': '被保險者證號碼',
  'pages.employeeList.healthInsurance.help':
    '三項可以全部留空；填寫任意一項時，必須將三項全部填寫完整。',
  'pages.employeeList.healthInsurance.incomplete':
    '填寫健康保險資訊時，請完整填寫保險者號碼、被保險者證記號和被保險者證號碼。',
  'pages.employeeList.healthInsurance.digitsOnly': '只能輸入數字。',
  'pages.employeeList.healthInsurance.maxLength': '請輸入30位以內的數字。',
  'pages.invoiceList.taxCategory': '稅務區分',
  'pages.invoiceList.taxCategory.taxable': '課稅',
  'pages.invoiceList.taxCategory.nonTaxable': '非課稅',
  'pages.invoiceList.amount.subtotal': '小計',
  'pages.invoiceList.amount.taxableSubtotal': '課稅對象金額',
  'pages.invoiceList.amount.nonTaxableSubtotal': '非課稅金額',
  'pages.invoiceList.amount.tax': '消費稅 10%',
  'pages.invoiceList.amount.total': '合計金額',
  'pages.invoiceList.attendance.totalHours': '當月工作時間',
  'pages.invoiceList.attendance.status': '考勤狀態',
  'pages.invoiceList.attendance.status.unsubmitted': '未提交',
  'pages.invoiceList.attendance.status.pending': '待審批',
  'pages.invoiceList.attendance.status.approved': '已審批',
  'pages.invoiceList.attendance.export': '考勤匯出',
  'pages.invoiceList.attendance.export.excel': '匯出Excel',
  'pages.invoiceList.attendance.export.pdf': '匯出PDF',
  'pages.invoiceList.attendance.export.noTargets': '沒有可匯出的考勤人員。',
  'pages.accounting.salaryManagement.title': '薪資管理',
  'pages.accounting.salaryManagement.search.placeholder': '依員工ID／姓名／帳號搜尋',
  'pages.accounting.salaryManagement.search.button': '搜尋',
  'pages.accounting.salaryManagement.search.result': '搜尋結果',
  'pages.accounting.salaryManagement.search.countUnit': '件',
  'pages.accounting.salaryManagement.summary.companyActualIncome': '公司總實際收入',
  'pages.accounting.salaryManagement.summary.scope':
    '按所選月份的在職期間彙總公司實際收入。現在已離職或停用的人員，歷史在職月份仍計入；不受搜尋和分類影響。在職期間不明或離職後結算須核對。',
  'pages.accounting.salaryManagement.summary.pendingHelp':
    '存在無法計算的人員時，顯示「需要確認」，不將部分合計作為公司總收入。',
  'pages.accounting.salaryManagement.summary.pendingCount': '待確認人數',
  'pages.accounting.salaryManagement.reload': '重新載入',
  'pages.accounting.salaryManagement.filter.contractType': '契約形態',
  'pages.accounting.salaryManagement.filter.targetMonth': '對象年月',
  'pages.accounting.salaryManagement.contractType.contract': '契約員工',
  'pages.accounting.salaryManagement.contractType.employee': '契約・正式員工',
  'pages.accounting.salaryManagement.contractType.regular': '正式員工',
  'pages.accounting.salaryManagement.contractType.resigned': '已離職',
  'pages.accounting.salaryManagement.accountStatus.active': '使用中',
  'pages.accounting.salaryManagement.accountStatus.disabled': '停用',
  'pages.accounting.salaryManagement.status.active': '在職中',
  'pages.accounting.salaryManagement.status.undefined': '未定',
  'pages.accounting.salaryManagement.status.contractFinished': '契約期滿',
  'pages.accounting.salaryManagement.status.bpFinished': 'BP結束',
  'pages.accounting.salaryManagement.status.resigned': '已離職',
  'pages.accounting.salaryManagement.column.employeeId': '員工ID',
  'pages.accounting.salaryManagement.column.employeeName': '員工姓名',
  'pages.accounting.salaryManagement.column.accountStatus': '帳號狀態',
  'pages.accounting.salaryManagement.column.contractType': '契約形態',
  'pages.accounting.salaryManagement.column.status': '狀態',
  'pages.accounting.salaryManagement.column.currentSalary': '基本薪資',
  'pages.accounting.salaryManagement.column.specialAllowance': '特別津貼',
  'pages.accounting.salaryManagement.column.employerBurden': '公司額外負擔預估',
  'pages.accounting.salaryManagement.column.totalCompanyCost': '公司總成本',
  'pages.accounting.salaryManagement.column.projectRevenue': '案件收入',
  'pages.accounting.salaryManagement.column.companyActualIncome': '公司實際收入',
  'pages.accounting.salaryManagement.projectRevenueHelp':
    '所選月份的案件收入（預計、稅前）。已開票使用明細金額，未開票使用案件單價。',
  'pages.accounting.salaryManagement.companyActualIncomeHelp':
    '公司實際收入 = 案件收入 − 公司總成本。',
  'pages.accounting.salaryManagement.column.lastRaiseAmount': '最近加薪額',
  'pages.accounting.salaryManagement.column.lastRaiseDate': '最近加薪日',
  'pages.accounting.salaryManagement.column.nextRaisePlannedDate': '下次加薪預定日',
  'pages.accounting.salaryManagement.column.action': '操作',
  'pages.accounting.salaryManagement.modal.editTitle': '薪資資訊編輯',
  'pages.accounting.salaryManagement.modal.historyTitle': '加薪履歷',
  'pages.accounting.salaryManagement.modal.historyTitleWithName': '{name} 的加薪履歷',
  'pages.accounting.salaryManagement.label.beforeSaveCurrentSalary': '儲存前的基本薪資',
  'pages.accounting.salaryManagement.field.currentSalary': '基本薪資',
  'pages.accounting.salaryManagement.field.currentSalary.extra':
    '輸入目前基本薪資。即使只是修正資料而非登記加薪，也請在此更新。',
  'pages.accounting.salaryManagement.field.specialAllowance': '特別津貼',
  'pages.accounting.salaryManagement.field.specialAllowance.extra':
    '這是{month}月份的一次性津貼，會計入僱用保險、勞災保險及公司總成本。',
  'pages.accounting.salaryManagement.insuranceSettings.title': '保險計算設定',
  'pages.accounting.salaryManagement.field.socialInsuranceApplicable': '社會保險',
  'pages.accounting.salaryManagement.field.employmentInsuranceApplicable': '僱用保險',
  'pages.accounting.salaryManagement.field.careInsuranceMode': '介護保險判定',
  'pages.accounting.salaryManagement.option.applicable': '適用',
  'pages.accounting.salaryManagement.option.notApplicable': '不適用',
  'pages.accounting.salaryManagement.option.careAuto': '依出生日期自動判定',
  'pages.accounting.salaryManagement.option.careOn': '適用',
  'pages.accounting.salaryManagement.option.careOff': '不適用',
  'pages.accounting.salaryManagement.field.healthStandardOverride':
    '健康保險標準報酬月額（手動設定）',
  'pages.accounting.salaryManagement.field.pensionStandardOverride':
    '厚生年金標準報酬月額（手動設定）',
  'pages.accounting.salaryManagement.field.standardOverride.extra':
    '未填寫時會依基本薪資自動判定等級，僅在已有申報標準報酬月額時填寫。',
  'pages.accounting.salaryManagement.field.lastRaiseDate': '最近加薪日',
  'pages.accounting.salaryManagement.field.lastRaiseDate.extra':
    '需要登記最近一次加薪日期時填寫，儲存後會反映到履歷。',
  'pages.accounting.salaryManagement.field.lastRaiseAmount': '最近加薪額',
  'pages.accounting.salaryManagement.field.lastRaiseAmount.extra':
    '輸入最近一次加薪金額，和最近加薪日一起儲存時會反映到履歷。',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate': '下次加薪預定日',
  'pages.accounting.salaryManagement.field.nextRaisePlannedDate.extra':
    '如果已確定下次加薪計畫，請填寫此日期。',
  'pages.accounting.salaryManagement.history.column.raiseDate': '加薪日',
  'pages.accounting.salaryManagement.history.column.beforeCurrentSalary': '加薪前基本薪資',
  'pages.accounting.salaryManagement.history.column.afterCurrentSalary': '加薪後基本薪資',
  'pages.accounting.salaryManagement.history.column.raiseAmount': '加薪額',
  'pages.accounting.salaryManagement.history.column.nextRaisePlannedDate': '下次加薪預定日',
  'pages.accounting.salaryManagement.history.column.createdAt': '登記時間',
  'pages.accounting.salaryManagement.history.column.targetMonth': '對象年月',
  'pages.accounting.salaryManagement.history.column.updatedAt': '更新時間',
  'pages.accounting.salaryManagement.history.tab.salary': '加薪履歷',
  'pages.accounting.salaryManagement.history.tab.specialAllowance': '特別津貼履歷',
  'pages.accounting.salaryManagement.history.empty': '暫無履歷。',
  'pages.accounting.salaryManagement.history.deleteConfirm': '確定刪除這筆履歷嗎？',
  'pages.accounting.salaryManagement.history.guide.line1':
    '最新履歷會顯示在最上方，誤登記的履歷可以刪除。',
  'pages.accounting.salaryManagement.history.guide.line2':
    '刪除履歷後，列表中的最新薪資資訊也會依剩餘履歷重新計算。',
  'pages.accounting.salaryManagement.action.edit': '編輯',
  'pages.accounting.salaryManagement.action.history': '履歷',
  'pages.accounting.salaryManagement.action.save': '儲存',
  'pages.accounting.salaryManagement.action.cancel': '取消',
  'pages.accounting.salaryManagement.action.delete': '刪除',
  'pages.accounting.salaryManagement.msg.specialAllowanceHistoryLoadFailed':
    '取得特別津貼履歷失敗。',
  'pages.accounting.salaryManagement.msg.loadFailed': '取得薪資管理資料失敗。',
  'pages.accounting.salaryManagement.msg.filterFailed': '篩選薪資管理資料失敗。',
  'pages.accounting.salaryManagement.msg.saveSuccess': '薪資資訊已儲存。',
  'pages.accounting.salaryManagement.msg.saveFailed': '薪資資訊儲存失敗。',
  'pages.accounting.salaryManagement.msg.historyLoadFailed': '取得加薪履歷失敗。',
  'pages.accounting.salaryManagement.msg.historyDeleteSuccess': '加薪履歷已刪除。',
  'pages.accounting.salaryManagement.msg.historyDeleteFailed': '刪除加薪履歷失敗。',
  'pages.accounting.salaryManagement.guide.line1':
    '選擇對象年月後，透過「編輯」更新基本薪資、特別津貼和保險計算設定。',
  'pages.accounting.salaryManagement.guide.line2':
    '儲存最近加薪日與加薪額後會同步反映到履歷，誤登記可從「履歷」刪除。',
  'pages.accounting.salaryManagement.modal.guide.line2':
    '輸入最近加薪日和加薪額後，系統會將相同內容反映到加薪履歷。',
  'pages.accounting.salaryManagement.modal.guide.line3':
    '誤登記的加薪履歷可在儲存後從「履歷」畫面刪除。',
  'pages.accounting.salaryManagement.cost.outsideEmployment': '對象月份不在職',
  'pages.accounting.salaryManagement.cost.missingBaseSalary': '未登記基本薪資',
  'pages.accounting.salaryManagement.cost.reviewRequired': '需要確認',
  'pages.accounting.salaryManagement.cost.departureDateRequired': '離職日期未填寫',
  'pages.accounting.salaryManagement.cost.departureDateRequiredHelp':
    '停用帳號未填寫離職日期，請核對所選月份的在職情況和成本，不能用0或10萬固定成本代替。',
  'pages.accounting.salaryManagement.cost.settlementReview': '結算待確認',
  'pages.accounting.salaryManagement.cost.settlementReviewHelp':
    '在職期間外存在案件收入或特別津貼，請核對該月結算，不自動計入目前薪資或10萬固定成本。',
  'pages.accounting.salaryManagement.cost.rateNotConfigured': '費率未設定',
  'pages.accounting.salaryManagement.cost.breakdownTitle': '公司額外負擔預估明細',
  'pages.accounting.salaryManagement.cost.healthStandard': '健康保險標準報酬月額',
  'pages.accounting.salaryManagement.cost.pensionStandard': '厚生年金標準報酬月額',
  'pages.accounting.salaryManagement.cost.health': '健康保險',
  'pages.accounting.salaryManagement.cost.pension': '厚生年金',
  'pages.accounting.salaryManagement.cost.employment': '僱用保險',
  'pages.accounting.salaryManagement.cost.workersComp': '勞災保險',
  'pages.accounting.salaryManagement.cost.childRelated': '育兒相關負擔',
  'pages.accounting.salaryManagement.cost.childRelatedDetail':
    '兒童育兒支援金 {support}／兒童育兒拠出金 {contribution}',
  'pages.accounting.salaryManagement.cost.care': '介護保險',
  'pages.accounting.dashboard.title': '財務儀表板',
  'pages.accounting.dashboard.subtitle': '從發票收入扣除契約員工與正式員工人力總成本後的概算結果。',
  'pages.accounting.dashboard.monthSuffix': '月',
  'pages.accounting.dashboard.mode.forecast': '預估',
  'pages.accounting.dashboard.tax.excluded': '未稅',
  'pages.accounting.dashboard.tax.included': '含稅',
  'pages.accounting.dashboard.metric.revenue': '發票收入',
  'pages.accounting.dashboard.metric.personnelCost': '人力總成本',
  'pages.accounting.dashboard.metric.profit': '扣除人力成本後概算利潤',
  'pages.accounting.dashboard.section.monthly': '{month}月',
  'pages.accounting.dashboard.section.annual': '{year}年合計',
  'pages.accounting.dashboard.note.selectedMonth': '所選月份',
  'pages.accounting.dashboard.note.salaryFormula': '基本薪資 + 特別津貼 + 公司負擔預估額',
  'pages.accounting.dashboard.note.annual': '1月至12月合計',
  'pages.accounting.dashboard.note.margin': '利潤率 {margin}',
  'pages.accounting.dashboard.table.title': '12個月明細',
  'pages.accounting.dashboard.table.month': '月份',
  'pages.accounting.dashboard.table.baseSalary': '基本薪資',
  'pages.accounting.dashboard.table.specialAllowance': '特別津貼',
  'pages.accounting.dashboard.table.employerBurden': '公司負擔預估額',
  'pages.accounting.dashboard.table.margin': '利潤率',
  'pages.accounting.dashboard.table.warningCount': '待確認人數',
  'pages.accounting.dashboard.status.review': '待確認',
  'pages.accounting.dashboard.warning.title': '部分月份需要確認計算條件',
  'pages.accounting.dashboard.warning.description':
    '基本薪資、生日或費率缺失、離職日期未填寫或在職期間外存在結算的月份，成本與利潤顯示待確認。現在帳號停用不影響歷史在職月份的計算。',
  'pages.accounting.dashboard.message.loadFailed': '財務儀表板載入失敗。',
  'pages.attendanceInput.submitConfirm.title': '考勤提交確認（{year}年{month}月）',
  'pages.attendanceInput.submitConfirm.message': '請先補全當月考勤資訊後再提交，並確認沒有遺漏。',
  'pages.attendanceInput.submitConfirm.editLock': '提交後將無法編輯。',
  'pages.attendanceInput.submitConfirm.ok': '確認並提交',
  'pages.attendanceInput.submitConfirm.cancel': '返回檢查',
  'pages.development.learnManagement.progress.evaluation.title': '評價',
  'pages.development.learnManagement.progress.evaluation.empty': '未填寫',
  'pages.development.learnManagement.progress.evaluation.edit': '編輯評價',
  'pages.development.learnManagement.progress.evaluation.save': '儲存',
  'pages.development.learnManagement.progress.evaluation.cancel': '取消',
  'pages.development.learnManagement.progress.evaluation.placeholder': '請輸入評價（最多100字）',
  'pages.development.learnManagement.progress.evaluation.saved': '評價已儲存。',
  'pages.development.learnManagement.progress.evaluation.saveFailed':
    '評價儲存失敗，請檢查輸入內容後重試。',
  'pages.development.learnManagement.progress.evaluation.tooLong':
    '評價最多100字，既有內容不會被自動截斷。',
};
